export const BITSTOP_OPERATOR_NAME = "ATM OPS";
